export default "__VITE_ASSET__Bzfc$pJ3__"